import { GoogleSpreadsheet } from 'google-spreadsheet';
import { useState, useEffect } from 'react';
import Header from './Header';
import TopMetrics from './TopMetrics';
import TeamPerformanceTable from './TeamPerformanceTable';
import PerformanceComparison from './PerformanceComparison';
import Chart from './Chart';

const GOOGLE_API_KEY = "AIzaSyDgNzi2LzJ5AyOeQ8az2NKhpALWcAvWqVQ";

const Dashboard = () => {

  const [monthYear, setMonthYear] = useState({ month: 'January', year: 2026 });
  const [monthData, setMonthData] = useState();
  const [annualData, setAnnualData] = useState();
  const [reportType, setReportType] = useState('monthly');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      if (!loading) {
        setLoading(true);
      }
      const doc = new GoogleSpreadsheet('1BnZeBIGgOiPdzVC431cUYpzOv0ahL_L2GsjgpJeucL4',
        { apiKey: GOOGLE_API_KEY }
      );
      await doc.loadInfo();

      const m_sheet = doc.sheetsByIndex[1];
      const m_cells = await m_sheet.getCellsInRange('A1:O45')
      setMonthData(m_cells);
      console.log('bruh')

      const a_sheet = doc.sheetsByIndex[2];
      const a_cells = await a_sheet.getCellsInRange('A1:O45')
      setAnnualData(a_cells);
      setLoading(false);
      setMonthYear({
        month: m_cells[2][1].split(' ')[0],
        year: m_cells[2][1].split(' ')[1]
      })
    }

    fetchData();
    const id = setInterval(fetchData, 1000 * 60 * 60);
    return () => clearInterval(id);
  }, []);



  function setReportTypeHandler() {
    setReportType(reportType === 'monthly' ? 'annual' : 'monthly');
  }

  if (loading) {
    return <p className='text-2xl font-bold align-middle min-h-screen bg-gradient-to-br text-center from-slate-950 to-slate-900 text-white p-8 relative overflow-hidden'>Loading...</p>
  }

  let headerMetrics, totals, platformData, chartData, data, title;
  let teamData = [];


  if (reportType === 'monthly') {
    data = monthData;
    title = 'KV - Detailed Month Report';
  } else {
    data = annualData;
    title = 'KV - Detailed Annual Report'
  }
  headerMetrics = {
    totalRevenue: data[3][2],
    totalCogs: data[3][5],
    totalProfit: data[3][8],
    roi: data[3][11]
  };


  const acc_index = data.findIndex(item =>
    item[1] === "Account"
  );

  const totals_index = data.findIndex(item =>
    item[1] === "Totals"
  );

  for (let index = acc_index + 1; index < totals_index; index++) {
    if (data[index].length !== 0) {
      teamData.push({
        account: data[index][1],
        stores: data[index][3],
        revenue: data[index][5],
        cogs: data[index][8],
        profit: data[index][11]
      })
    }
  }

  while (teamData.length < 5) {
    teamData.push({
      account: ' ‎ ',
      stores: '',
      revenue: '',
      cogs: '',
      profit: ''
    })
  }

  totals = {
    orders: data[totals_index][3],
    revenue: data[totals_index][5],
    cogs: data[totals_index][8],
    profit: data[totals_index][11]
  };

  const amazon_index = data.findIndex(item =>
    item[1] === "Amazon Total"
  );

  const ebay_index = data.findIndex(item =>
    item[1] === "eBay Total"
  );

  const tiktok_index = data.findIndex(item =>
    item[1] === "TikTok Total"
  );

  platformData = {
    amazon: {
      revenue: data[amazon_index + 1][5],
      cogs: data[amazon_index + 2][5],
      profit: data[amazon_index + 3][5],
      roi: data[amazon_index + 4][5]
    },
    ebay: {
      revenue: data[ebay_index + 1][5],
      cogs: data[ebay_index + 2][5],
      profit: data[ebay_index + 3][5],
      roi: data[ebay_index + 4][5]
    },
    tiktok: {
      revenue: data[tiktok_index + 1][5],
      cogs: data[tiktok_index + 2][5],
      profit: data[tiktok_index + 3][5],
      roi: data[tiktok_index + 4][5]
    }
  };

  chartData = [
    {
      name: 'Tiktok',
      Revenue: platformData.tiktok.revenue.replace(/[$\s]/g, '').replace(',', '.'),
      COGs: platformData.tiktok.cogs.replace(/[$\s]/g, '').replace(',', '.'),
      Profit: platformData.tiktok.profit.replace(/[$\s]/g, '').replace(',', '.')
    },
    {
      name: 'eBay',
      Revenue: platformData.ebay.revenue.replace(/[$\s]/g, '').replace(',', '.'),
      COGs: platformData.ebay.cogs.replace(/[$\s]/g, '').replace(',', '.'),
      Profit: platformData.ebay.profit.replace(/[$\s]/g, '').replace(',', '.')
    },
    {
      name: 'Amazon',
      Revenue: platformData.amazon.revenue.replace(/[$\s]/g, '').replace(',', '.'),
      COGs: platformData.amazon.cogs.replace(/[$\s]/g, '').replace(',', '.'),
      Profit: platformData.amazon.profit.replace(/[$\s]/g, '').replace(',', '.')
    }
  ];


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 to-slate-900 text-white p-8 relative overflow-hidden">
      <div className='absolute inset-0 overflow-hidden pointer-events-none'>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-gradient-to-br from-blue-200/20 to-blue-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-gradient-to-br from-blue-200/10 to-blue-500/10 rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto relative z-10">
        <Header title={title} monthYear={monthYear} onTypeChange={setReportTypeHandler} reportType={reportType} />
        <div className='grid grid-cols-2 gap-8'>
          <div className='space-y-8'>
            <TopMetrics headerMetrics={headerMetrics} />
            <TeamPerformanceTable teamData={teamData} totals={totals} />
          </div>
          <div className='space-y-8'>
            <PerformanceComparison platformData={platformData} />
            <Chart data={chartData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
